/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_3_BodyInputs */

const en_about_principle_3_body = /** @type {(inputs: About_Principle_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We plan ownership and support before launch. The handover and the ongoing operation are part of the conversation from the start.`)
};

const lv_about_principle_3_body = /** @type {(inputs: About_Principle_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildību un atbalstu plānojam pirms ieviešanas. Nodošana un ikdienas darbība ir sarunas daļa jau no paša sākuma.`)
};

/**
* | output |
* | --- |
* | "We plan ownership and support before launch. The handover and the ongoing operation are part of the conversation from the start." |
*
* @param {About_Principle_3_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_3_body = /** @type {((inputs?: About_Principle_3_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_3_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_3_body(inputs)
	return en_about_principle_3_body(inputs)
});